import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import cx from 'classnames';

import withStyles from '@mui/styles/withStyles';
import IconButton from '@mui/material/IconButton';
import TrashcanIcon from '@mui/icons-material/Delete';

import { deleteDocument } from '../store/slices/documentsSlice';
import { setApiResponseInfo } from '../store/slices/apiResponseInfoSlice';

import { createStdRequest, apiFetch, showAlert } from '../utils/utils';

import docsAssocGroupStyles from '../assets/jss/crm/components/docsAssocGroupStyles';

import ConfirmModal from './ConfirmModal';
import AlertModal from './AlertModal';
import DocPreviewModal from './DocPreviewModal';

class DocSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      docstoView: undefined,
      shouldShowPreviewModal: false,
    };
  }

  showUIToPreviewDocument = (event) => {
    event.stopPropagation();
    this.setState({ shouldShowPreviewModal: true });
  };

  offerToDeleteDocument(document) {
    this.confirmAndMaybeRemoveDocument(document);
  }

  confirmAndMaybeRemoveDocument(document) {
    const q = `Are you sure you want to remove this document?`;
    this.setState({
      shouldShowDeletionConfirmationModal: true,
      deletionConfirmationQuery: q,
      deleteDocumentFunc: () => this.removeDocument(document),
    });
  }

  removeDocument(document) {
    if (document.personId > 0) {
      const uri = `/api/document/${document.storedDocumentId}`;
      const request = createStdRequest(uri, 'delete');
      const actionOnGoodResponse = () => {
        this.props.deleteDocument(document.storedDocumentId);
      };
      apiFetch(this, request, actionOnGoodResponse);
    } else {
      if (document.storedDocumentId > 0) {
        const deletedDocIds = this.props.parent.state.deletedDocIds;
        const extendedDeletedDocIds = [...deletedDocIds, document.storedDocumentId];
        this.props.parent.setState({ deletedDocIds: extendedDeletedDocIds });
      }
      const docsList = this.props.parent.state.docs;
      const prunedDocs = docsList.filter((el) => el !== document);
      this.props.parent.setState({ docs: prunedDocs, isDocModified: true });
      this.setState({ shouldShowDeletionConfirmationModal: false });
    }
  }

  showModalForDocument(doc) {
    showAlert(this, 'a story is needed for this document modal');
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }

    const { classes, document, parent } = this.props;

    return (
      <div>
        <AlertModal show={this.state.shouldShowAlertModal} renderer={this} text={this.state.alertModalText} />

        <ConfirmModal
          show={this.state.shouldShowDeletionConfirmationModal}
          title="Confirm Deletion"
          confirmButtonLabel="Delete"
          rejectButtonLabel="Cancel"
          onConfirm={this.state.deleteDocumentFunc}
          onReject={() => this.setState({ shouldShowDeletionConfirmationModal: false })}
        >
          <div>{this.state.deletionConfirmationQuery}</div>
        </ConfirmModal>

        <DocPreviewModal
          show={this.state.shouldShowPreviewModal}
          document={document}
          documentDescription={document.description}
          storedDocumentId={document.storedDocumentId}
          closeModalFunc={() => this.setState({ shouldShowPreviewModal: false })}
          parent={parent}
        />
        <div className={cx(classes.entitySummary, classes.entitySummary_task, classes.docSummary_leftPanel)}>
          <div className={classes.docSummary_buttonContainer}>
            <IconButton
              aria-label="Delete"
              color="inherit"
              onClick={() => this.offerToDeleteDocument(document)}
              size="large"
            >
              <TrashcanIcon className={cx(classes.icon_darkenOnHover, classes.iconSize)} />
            </IconButton>
          </div>
          <div
            className={cx(classes.entitySummary_title, classes.u_cursorPointer, classes.u_ellipsis, classes.ac_h4)}
            onClick={(event) => this.showUIToPreviewDocument(event)}
          >
            {document.publicName}
          </div>
          <div className={cx(classes.entitySummary_subtitle, classes.u_ellipsis, classes.ac_h5)}>
            <div className={classes.entitySummary_subtitleName}>
              {document.typeTag ? document.typeTag : 'Unknown Type'}
              {document.description ? ' / ' + document.description : ''}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const actionProducers = {
  deleteDocument,
  setApiResponseInfo,
};

export default connect(null, actionProducers)(withStyles(docsAssocGroupStyles)(DocSummary));
